import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import {
  newNextAction,
  NEW_NEXT,
} from '../../actions/navigation';

import Header from '../../components/Header';
import Button from '../../components/Button';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import Container from '../../components/Container';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Footer from '../../components/Footer';
import ApplicationId from '../../components/ApplicationId';

// Configuration & Assets
import { useConfig } from '../../config/ConfigContext';
import imgPreApproved from '../../assets/images/preapproved.svg';

const PreApproved = (props) => {
  const config = useConfig();
  const { navigate, checkinData, params, searchParams } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(null);
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  useEffect(() => {
    const { fetch } = props;

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [props.checkinData]);

  const handleButtonClick = (e) => {
    e.preventDefault();
    const { dispatch } = props;

    setIsProgressVisible(true);
    dispatch(newNextAction({
      key,
      workflowType: workflowType || 'text2apply',
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  };

  return (
    <Transition className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(props.checkinData, 'attributes.entityId')} inHeadline />
      <Container className="content appIdVisible">
        <img src={imgPreApproved} alt="" />
        <h1>
          Congratulations!
          {' '}
          <br />
          You’re Pre-Approved
        </h1>
        <p>On the next screen you’ll review your options and select your loan.</p>
      </Container>
      <Footer>
        <FormRow>
          <FormColumn>
            <Button
              className="btn arrow btn-primary"
              onClick={handleButtonClick}
              title="Next: Select Your Loan"
            />
          </FormColumn>
        </FormRow>
      </Footer>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </Transition>
  );
};

PreApproved.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(PreApproved);
